// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"02b7ace9","455":"dbcbda35","977":"167a675f"}[chunkId] + ".chunk.js";
};